<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >
            {{ $t('button.create') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
    >
      <el-table-column
        label="Name"
        prop="name"
        width="300"
      />

      <el-table-column
        label="Phone"
        prop="phone"
        width="200"
      />

      <el-table-column
        label="Email"
        prop="email"
      />

      <el-table-column
        fixed="right"
        label="Action"
        align="center"
        width="100"
      >
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import { createComponent, onBeforeMount, ref, reactive } from '@vue/composition-api'
import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'

import PrivateClientsService from '../../api/private-clients'

const PrivateClientList = createComponent({
  name: 'PrivateClientList',
  components: {
    ListPageHeader,
  },
  setup(props, { root }) {
    const { $router, $confirm } = root

    const isLoading = ref(false)
    const list = ref([])

    const getList = async () => {
      isLoading.value = true

      const { data } = await PrivateClientsService.getClientList()

      isLoading.value = false

      list.value = data
    }

    onBeforeMount(() => {
      getList()
    })

    const handleCreate = () => {
      $router.push({ path: '/private-client/client/create' })
    }

    const handleUpdate = (item) => {
      $router.push({ path: `/private-client/client/edit/${item.id}` })
    }

    return {
      list,
      handleCreate,
      handleUpdate,
      isLoading,
    }
  },
})

export default PrivateClientList

</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

::v-deep {
  .el-tag {
    white-space: normal;
    height: auto;
    word-break: break-word;
  }
  .el-table__row {
    .cell {
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
